import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setFilters } from "@/redux/vendor.search.slice";
import { regions } from "@/constants/regions";
import BrisbaneImage from "@/assets/Brisbane.jpeg";

const cities = [
  {
    name: "Sydney",
    image: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=400",
    professionals: [
      { type: "Mortgage Brokers", count: "150+ Available" },
      { type: "Conveyancers", count: "200+ Available" },
      { type: "Building & Pest inspector", count: "100+ Available" },
      { type: "Buyers Agent", count: "100+ Available" },
    ],
  },
  {
    name: "Melbourne",
    image: "https://images.unsplash.com/photo-1514395462725-fb4566210144?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=400",
    professionals: [
      { type: "Mortgage Brokers", count: "120+ Available" },
      { type: "Conveyancers", count: "180+ Available" },
      { type: "Building & Pest inspector", count: "100+ Available" },
      { type: "Buyers Agent", count: "90+ Available" },
    ],
  },
  {
    name: "Brisbane",
    image: BrisbaneImage,
    professionals: [
      { type: "Mortgage Brokers", count: "80+ Available" },
      { type: "Conveyancers", count: "110+ Available" },
      { type: "Building & Pest inspector", count: "100+ Available" },
      { type: "Buyers Agent", count: "60+ Available" },
    ],
  },
];

export function ProfessionalsSection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleRegionClick = (cityName) => {  
    localStorage.setItem("homePage", "false");
    dispatch(
      setFilters({
        vendorType: [],
        rating: null,
        serviceType: [],
      })
    );
    // Find region by city name
    const region = regions.find(r => r.name === cityName);

    if (region && region.location) {
      localStorage.setItem("selectedVendorLocation", JSON.stringify(region.location));
    }
    navigate("/customer/search-brokers");
  };

  return (
    <section id="professionals" className="py-20 bg-gray-50 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Professional Services Across Australia
          </h2>
          <p className="text-xl text-gray-600">
            Expert professionals ready to help in major cities
          </p>
        </motion.div>

        {/* Services by City */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {cities.map((city, index) => (
            <motion.div
              key={city.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <Card className="overflow-hidden hover:shadow-xl transition-all duration-300">
                <div className="h-48 overflow-hidden">
                  <img
                    src={city.image}
                    alt={`${city.name} cityscape`}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                </div>
                <CardContent className="p-6">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">
                    {city.name}
                  </h3>
                  <div className="space-y-3 mb-6">
                    {city.professionals.map((professional) => (
                      <div
                        key={professional.type}
                        className="flex items-center justify-between"
                      >
                        <span className="text-gray-600">{professional.type}</span>
                        {/* <Badge className="bg-hbn-blue text-white">
                          {professional.count}
                        </Badge> */}
                      </div>
                    ))}
                  </div>
                  <Button className="w-full bg-[rgb(106,0,244)] text-white hover:bg-hbn-blue-dark"
                    onClick={() => handleRegionClick(city.name)}>
                    View {city.name} Professionals
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
